import React, { Component} from 'react';
 
import API from'../utilities/API'
import {  NavLink, Redirect  } from 'react-router-dom'

class LogIn extends Component {
 
  constructor(props) {
    super(props);


    this.state = {
      uname: '',
      upwd:'',
      logged:false,
    }
     
  
    
  }

handleLoginRet=(usr)=>{
  
  console.log('usr',usr)
  if(usr.usr!==false){
    console.log("HERE")
    this.props.setUser(usr);
    this.setState({logged:true})
    this.props.LogIn();
  }
    
    
}

handleLogin = e => {    
    e.preventDefault();  
    API.login(this.state.uname, this.state.upwd, this.handleLoginRet);
        
     
    };
  
 
    



  handleOnChange = event => {
      event.preventDefault();
      const { name, value } = event.target;
      
      this.setState({
        [name]: value
      });
    }

   
    render() { 

      return (this.state.logged===true)?(<Redirect to='/'/>):(
              <div className='mypage fluid-container p-3'>
                <h2>Login</h2>  
                
                <div className='row'>
                <div className='myfldlbl col-12 mx-2'>Email</div>
                <div className='col-xs-12 col-sm-6 col-md-4 mx-2'><input className="form-control" name="uname" value={this.state.uname}  onChange={this.handleOnChange} type='text'/></div>
                <div className='myerr col-12 mx-2'>{this.state.errE}</div>
                </div>
  
                <div className='row'>
                <div className='myfldlbl col-12 mx-2'>Password</div>
                <div className='col-xs-12 col-sm-6 col-md-4 mx-2'><input className="form-control"name="upwd" value={this.state.upwd} onChange={this.handleOnChange} type='password'/></div>
                <div className='myerr col-12 mx-2'>{this.state.errP}</div>
                </div>
  
  
                <div className='row'>
                  <div className='col-3 mx-2'>
                    <div className="btn btn-dark mt-2" value="" to="/"  onClick={this.handleLogin}>Login</div>
                    <NavLink className="nav-link" value="" to="/password/request">Psst? Password Reset HERE!!!!</NavLink>  
                    <NavLink className="nav-link" value="" to="/register">New Here? Register and play for free!!!!</NavLink>    
                  </div>
                  <div className='col-3 mx-2'>
                  
                </div>
                <div className='col-3 mx-2'>
                    
                  </div>
                </div>
                </div>
                 
                
              );            
              
  
      
    }  

  
}




export default LogIn; 


// WEBPACK FOOTER //
// ./src/components/LogIn.js